module.exports = __webpack_public_path__ + "img/liuyan@2x.381a13cd.png";